import styled from "styled-components";

type Props = {
	disabled?: boolean;
};

export const ButtonContainer = styled.div`
  width: 100%;
  display: flex;
  ${({ disabled }: Props) => {
		if (disabled) {
			return `
          button{
            background-color:#ccc;
            pointer-events:none;
          }
      `;
		}
	}}
`;

export const NewPasswordLabel = styled.span`
font-family: "Filson";
font-size: 14px;
letter-spacing: 0.03em;
color: #33403E;
font-weight: 500;
line-height: 1.25;
margin-bottom: 4px;
`;
